import helper from 'helpers/steinerHelper';
import client from 'apis/apiCalendarioAttivita';
import clientReport from "apis/apiReportCalendar"

const paramsMapTracciamento = {
    dataInizio: 'dataInizio',
    dataFine: 'dataFine',
    utente: 'utente',
};

const apis = helper.createApi(
    'tracciamenti-attivita',
    client,
    paramsMapTracciamento
);

apis.clienti = helper.createApi('clienti', client /*paramsMap*/);
apis.attivita = helper.createApi('attivita', client /*paramsMap*/);

apis.fetchAttivitaHotel = (aoHotelId) => {
    return client({
        url: `attivita?aoHotelId=${aoHotelId}`,
    });
};

apis.fetchReport = (dataInizio, dataFine, utente) => {
    return clientReport({
        url: `tracciamenti-attivita/report?dataInizio=${dataInizio}&dataFine=${dataFine}&utente=${utente}`,
        method: "GET"
    });
}
export default apis;
